import React from "react";
import { TextField } from "@material-ui/core";

const NormalTextField = ({ params, label }) => {
  return <TextField {...params} variant="outlined" label={label} />;
};

export default NormalTextField;
